(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bk-floating-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bk-floating-filter-controller')) {
    customElements.define('bk-floating-filter-controller', class extends HTMLElement {
      connectedCallback() {
        this.scheduleUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.updateVisibility();
          });
        };
        this.intersections = new IntersectionObserver(this.scheduleUpdate);
        this.changes = new MutationObserver(this.scheduleUpdate);
        this.changes.observe(document.querySelector('main') || document.body, {
          childList: true,
          subtree: true
        });
        window.addEventListener('resize', this.scheduleUpdate);
        window.addEventListener('pageshow', this.scheduleUpdate);
        this.updateVisibility();
      }

      updateVisibility() {
        const section = document.querySelector('.shopify-section--main-collection');
        const root = section?.querySelector('#cloud_search_filters_root');
        const grid = section?.querySelector('product-list');
        const boundary = grid?.querySelector('product-card')
          ? grid
          : section?.querySelector('.empty-state');

        if (boundary !== this.boundary) {
          this.intersections.disconnect();
          this.boundary = boundary;
          if (boundary) this.intersections.observe(boundary);
        }

        root?.toggleAttribute('data-bk-filter-past-products',
          Boolean(boundary && boundary.getBoundingClientRect().bottom <= 0));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.intersections.disconnect();
        this.changes.disconnect();
        window.removeEventListener('resize', this.scheduleUpdate);
        window.removeEventListener('pageshow', this.scheduleUpdate);
        document.querySelector('#cloud_search_filters_root')?.removeAttribute('data-bk-filter-past-products');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
